import classNames from "classnames";
import { BaseButton } from "../../../components/Button/BaseButton.tsx";
import { Icon, type IconName } from "../../../components/Icon/Icon.tsx";
import { useIsUserWorkspaceOwner } from "../../hooks/useIsUserWorkspaceOwner.ts";
import { profileSettingsDialogStore } from "./stores/profileSettingsDialogStore.ts";

export const NavigationPanel = () => {
  const isUserWorkspaceOwner = useIsUserWorkspaceOwner();
  const { profileSettingsTab } = profileSettingsDialogStore.useState();

  return (
    <div className="w-[168px] flex-col pt-300">
      <div className="flex-col px-200 gap-300">
        <div>
          <NavPrimaryItem title="Account" icon="User" />
          <NavSecondaryItem
            title="Profile"
            onClick={() =>
              profileSettingsDialogStore.setProfileSettingsTab("profile")
            }
            isSelected={profileSettingsTab === "profile"}
          />
        </div>
        {isUserWorkspaceOwner && (
          <div>
            <NavPrimaryItem title="Workspace" icon="Building" />
            <NavSecondaryItem
              title="General"
              onClick={() =>
                profileSettingsDialogStore.setProfileSettingsTab("general")
              }
              isSelected={profileSettingsTab === "general"}
            />
            <NavSecondaryItem
              title="Members"
              onClick={() =>
                profileSettingsDialogStore.setProfileSettingsTab("members")
              }
              isSelected={profileSettingsTab === "members"}
            />
            <NavSecondaryItem
              title="Plan & billing"
              onClick={() =>
                profileSettingsDialogStore.setProfileSettingsTab("plan")
              }
              isSelected={profileSettingsTab === "plan"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const NavPrimaryItem = ({ title, icon }: { title: string; icon: IconName }) => (
  <div className="h-800 w-full px-150 flex-row-center gap-150">
    <Icon name={icon} size="md" className="stroke-secondary-rest" />
    <div className="flex-fill label-md-semibold text-disabled">{title}</div>
  </div>
);

const NavSecondaryItem = ({
  title,
  onClick,
  isSelected,
}: {
  title: string;
  onClick?: () => void;
  isSelected: boolean;
}) => (
  <BaseButton
    onClick={onClick}
    className={classNames(
      "w-full rounded-150",
      isSelected ? "bg-surface-primary-active" : "bg-surface-primary-rest",
    )}
  >
    <div className="h-800 pl-800 pr-200 flex-row-center gap-150">
      <div
        className={classNames(
          "flex-fill",
          isSelected
            ? "label-md-semibold text-primary"
            : "label-md-default text-secondary",
        )}
      >
        {title}
      </div>
    </div>
  </BaseButton>
);
